import autobind from "autobind-decorator"
const createHistory = require("history").createHashHistory;

class Core {
  /**
   * Constructor
   */
  constructor() {
    this._routes = []
    this._drawerItems = []
    this._routeHistory = createHistory()
  }

  /**
   * routes getter
   */
  get routes() {
    return this._routes
  }

  /**
   * drawer items getter
   */
  get drawerItems() {
    return this._drawerItems
  }

  /**
   * route history
   */
  get routeHistory() {
    return this._routeHistory
  }

  /**
   * add a route
   * @param { Object } route item to add route
   * @return { Array } new routes
   */
  addRoute(route) {
    this._routes.push(route)

    return this
  }

  /**
   * add routes
   * @param { Array } routes routes to add route
   * @return { Array } new routes as array
   */
  addRoutes(routes) {
    this._routes = [...this._routes, routes]

    return this
  }

  /**
   * add a new entry to menu
   * @param { Object } menu item to add drawer
   * @returns { Array }
   */
  addDrawerMenu(menu) {
    this._drawerItems.push(menu)

    return this
  }
  /**
   * add drawer menu items
   * @param { Object } menus item to add drawer
   * @return { Array } new drawer menus
   */
  addDrawerMenus(menus) {
    this._drawerItems = [...this._drawerItems, menus]
  }
}

const _Core = autobind(Core)

export default {
  init() {
    return new _Core()
  }
}
